module.exports = {
    handle: (e, name) => {   
        dataLayer.push({ ecommerce: null });        
        dataLayer.push({
            'event': `e.${name}Start`
        });
    }
}